// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"02f13192","981":"0b82a52e"}[chunkId] + ".chunk.js";
};